import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import { renderTextField } from './form_helpers'
import RaisedButton from 'material-ui/RaisedButton'

const styles = {
  center: {
    width: 256,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}

class SigninForm extends Component {

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Oops: </strong>{this.props.errorMessage}
      </div>
    }
  }

  render() {
    // const {handleSubmit} = this.props

    return (
      <div>
        {this.renderAlert()}
        <form onSubmit={this.props.handleSubmit} style={styles.center}>

          <Field
            label="felhasználónév"
            name="email"
            component={renderTextField}
            type="text"/>

          <Field
            label="jelszó"
            name="password"
            component={renderTextField}
            type="password"/>

          <RaisedButton type="submit" label="Bejelentkezés" primary={true} labelColor={'#FFFFFF'}/>
        </form>
      </div>
    )
  }
}

export default reduxForm({
  form: 'signin'
})(SigninForm)



// WEBPACK FOOTER //
// ./src/components/auth/signin_form.js